<template>
	<div>
		<div class="modal__content">
			<p class="text-center mb20">Are you sure you want to remove all information associated with your <span class="text-color-green">{{args.name}}  {{args.surname}}</span> account?</p>

			<div class="flex flex--justify-center">
				<button class="btn btn--wide btn--gray-2 mr10" @click="$bus.$emit('modalClose')" type="button">No</button>
				<button class="btn btn--wide" @click="onUserRemoveAllInformation">Yes</button>
			</div>
		</div>
	</div>
</template>

<script>
import { apiUserRemoveAllInformation } from '@/api/project.api'
import { errorMessage } from 'modules/Error'
export default {
  props: ['args'],
  data () {
    return {
    }
  },
  created () {},
  methods: { 
    async onUserRemoveAllInformation () { 
      const [err, data] = await apiUserRemoveAllInformation()
      if (err) return errorMessage(err, 'Unable delete your identity')

      if (!data.status) return this.$bus.$emit('toastError', `Error: ${data.explanation}`)
      this.$bus.$emit('toastSuccess', data.explanation)
      return setTimeout(() => { this.$bus.$emit('logout') }, 2000)
    }
  }

}

</script>


// WEBPACK FOOTER //
// RemoveAllUserInformation.vue?1a38783f